import React, { useState, createContext, useContext } from 'react'

type Theme = 'dark' | 'light'

interface ThemeContextType {
  theme: Theme
  toggleTheme: () => void
}

const ThemeContext = createContext<ThemeContextType>({
  theme: 'dark',
  toggleTheme: () => {},
})

export const ThemeProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>('dark')

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'))
  }

  return (
    <ThemeContext.Provider
      value={{
        theme,
        toggleTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => useContext(ThemeContext)

export const themeStyles = {
  dark: {
    background: 'from-[#2D3436] to-[#0D0F1A]',
    panel: 'bg-white/20',
    text: 'text-white',
    border: 'border-white/20',
    glow: 'shadow-[#6C5CE7]',
    accent: 'from-[#6C5CE7] to-[#00CEC9]',
  },
  light: {
    background: 'from-[#EBF4FF] to-[#E6E6FA]',
    panel: 'bg-white/80',
    text: 'text-[#2D3748]',
    border: 'border-blue-200/40',
    glow: 'shadow-[#A0AEC0]',
    accent: 'from-[#4B7BFF] to-[#8E44AD]',
    secondary: '#8E44AD',
    tertiary: '#4B7BFF',
    highlight: '#F5F7FF',
    cardBg: 'bg-gradient-to-br from-white to-[#F5F7FF]',
    softAccent: '#E6EFFF',
  },
} 